
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter } from "vuex-class"

@Component({})
export default class CaseFilter extends Vue {
}
